import { MonSisraApis } from "../apis/monsisra";
import type { IConfigurationFront } from "../apis/monsisra/generated.v2.public";

export class ConfigService {
	private static _config?: IConfigurationFront;

	static async getFrontConfig() {
		if (ConfigService._config) {
			return ConfigService._config;
		}

		const config = await MonSisraApis.config.getConfigurationFront();

		ConfigService._config = config;

		return config;
	}

	static get config() {
		if (!ConfigService._config) {
			throw new Error("ConfigService not initialized. Call getFrontConfig() first.");
		}
		return ConfigService._config;
	}
}